import 'css-chunksrc/client/scenes/assignToTask/styles.scss';export default {
  "assignToTask": "_assignToTask_1xero_1",
  "body": "_body_1xero_9",
  "field": "_field_1xero_19",
  "label": "_label_1xero_27",
  "placeholder": "_placeholder_1xero_33",
  "footer": "_footer_1xero_41"
};